"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobileEntityLike = exports.MobileEntity = exports.MobileEntityClassName = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const DeviceEnabledType_1 = require("./Device/DeviceEnabledType");
exports.MobileEntityClassName = 'MobileEntity';
class MobileEntity extends DeviceEnabledType_1.DeviceEnabledType {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.MobileEntityClassName)
            throw new Error(`Tried to create a ${exports.MobileEntityClassName} from a ${ob.type} object!`);
        super(exports.MobileEntityClassName, { ...ob });
        this.type = ob.type ?? exports.MobileEntityClassName;
        this.location = ob.location ?? undefined;
        this.accelerometer = ob.accelerometer ?? null;
        this.score_accelerometer = ob.score_accelerometer ?? null;
        this.batteryPercentage = ob.batteryPercentage ?? null;
        this.deviceBatteryVoltage = ob.deviceBatteryVoltage ?? null;
        this.rssi = ob.rssi ?? null;
        this.sf = ob.sf ?? null;
        this.snr = ob.snr ?? null;
        this.fCnt = ob.fCnt ?? null;
        this.deviceEui = ob.deviceEui ?? null;
        this.gatewayEui = ob.gatewayEui ?? null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                required: true,
                label: 'Name',
                name: 'name',
                description: 'identification',
                validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
            },
            accelerometer: {
                label: 'Accelerometer',
                type: 'Number',
                editable: false,
            },
        };
    }
}
exports.MobileEntity = MobileEntity;
const isMobileEntityLike = (ob) => {
    return (0, iotv_v3_types_1.isValidBusinessObject)(ob) && ob.type === exports.MobileEntityClassName;
};
exports.isMobileEntityLike = isMobileEntityLike;
